export const sessionConstants = {
  appLanguage: `appLanguage_${import.meta.env.VITE_PROJECT_ENV}`,
  mldReportJobMap: "mldReportJobMap",
};
